import React from "react";
import { Card, Tabs, Tab, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { isNull } from "lodash";
import LTAdvance from "./LTAdvance"
import STAdvance from "./STAdvance";
import HRLTLedger from "./HRLTLedger";
import HRSTLedger from "./HRSTLedger";

const HRVoucher = (props) => {
    const permissions = JSON.parse(localStorage.getItem("permissions"));

    return (
        <>
            <Tabs
                defaultActiveKey={!isNull(permissions) && permissions.some(p => p['sub_id'] === 69) ?
                "ltAdvance" : !isNull(permissions) && permissions.some(p => p['sub_id'] === 70) ?
                    "stAdvance" : !isNull(permissions) && permissions.some(p => p['sub_id'] === 77) ?
                    "ltAdvanceledger" : !isNull(permissions) && permissions.some(p => p['sub_id'] === 78) ?
                        "stAdvanceLedger" :""}>
                <Tab
                    eventKey="ltAdvance"
                    title="Long Term Advance"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 69) ? false : true}>
                    <LTAdvance />
                </Tab>
                <Tab
                    eventKey="stAdvance"
                    title="Short Term Advance"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 70) ? false : true}>
                    <STAdvance />
                </Tab>
                <Tab
                    eventKey="ltAdvanceledger"
                    title="Long Term Advance Report"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 77) ? false : true}>
                    <HRLTLedger />
                </Tab>
                <Tab
                    eventKey="stAdvanceLedger"
                    title="Short Term Advance Report"
                    unmountOnExit={true}
                    disabled={!isNull(permissions) && permissions.some(p => p['sub_id'] === 78) ? false : true}>
                    <HRSTLedger />
                </Tab>
            </Tabs>

        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
    };
};
const mapStateToProps = (state, ownProps) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HRVoucher);